/*
These functions make sure WordPress
and Foundation play nice together.
*/

function setCookie(cname, cvalue, exdays)
{
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname)
{
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i <ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

// Typewriter Effect

// List of sentences
var _CONTENT = [ 
	"hugs",
	"laughs",
	"family",
	"love"
];

// Current sentence being processed
var _PART = 0;

// Character number of the current sentence being processed 
var _PART_INDEX = 0;

// Holds the handle returned from setInterval
var _INTERVAL_VAL;

// Element that holds the text
var _ELEMENT = document.querySelector("#typewriter-text");

// Cursor element 
var _CURSOR = document.querySelector("#typewriter-cursor");

// Implements typing effect
function Type() { 
	// Get substring with 1 characater added
	var text =  _CONTENT[_PART].substring(0, _PART_INDEX + 1);
	_ELEMENT.innerHTML = text;
	_PART_INDEX++;

	// If full sentence has been displayed then start to delete the sentence after some time
	if(text === _CONTENT[_PART]) {
		// Hide the cursor
		//_CURSOR.style.display = 'none';

		clearInterval(_INTERVAL_VAL);
		setTimeout(function() {
			_INTERVAL_VAL = setInterval(Delete, 50);
		}, 2500);
	}
}

// Implements deleting effect
function Delete() {
	// Get substring with 1 characater deleted
	var text =  _CONTENT[_PART].substring(0, _PART_INDEX - 1);
	_ELEMENT.innerHTML = text;
	_PART_INDEX--;

	// If sentence has been deleted then start to display the next sentence
	if(text === '') {
		clearInterval(_INTERVAL_VAL);

		// If current sentence was last then display the first one, else move to the next
		if(_PART == (_CONTENT.length - 1))
			_PART = 0;
		else
			_PART++;
		
		_PART_INDEX = 0;

		// Start to display the next sentence after some time
		setTimeout(function() {
			_CURSOR.style.display = 'inline-block';
			_INTERVAL_VAL = setInterval(Type, 125);
		}, 200);
	}
}

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	var owl = jQuery("#product-categories");
	owl.owlCarousel({
		loop:false,
		dots:false,
		nav:true,
		navText:["<img src='/wp-content/uploads/2017/10/carousel-arrow-left.png'/>","<img src='/wp-content/uploads/2017/10/carousel-arrow-right.png'/>"],
		margin:30,
		autoplay:true,
		autoplayTimeout:10000,
		responsive:{
			0:{
				items:1
			},
			450:{
				items:1
			},
			768:{
				items:2
			},
			1025:{
				items:3
			},
			1440:{
				items:4
			},
			1800:{
				items:5
			}
		}
	});

	var owl2 = jQuery("#brand-logos");
	owl2.owlCarousel({
		loop:true,
		dots:false,
		nav:true,
		navText:["<img src='/wp-content/uploads/2017/10/carousel-arrow-left.png'/>","<img src='/wp-content/uploads/2017/10/carousel-arrow-right.png'/>"],
		margin:30,
		autoplay:true,
		autoplayTimeout:10000,
		responsive:{
			0:{
				items:1
			},
			450:{
				items:2
			},
			768:{
				items:3
			},
			1025:{
				items:4
			},
			1440:{
				items:5
			},
			1800:{
				items:5
			}
		}
	});

	jQuery( '#brand-logos a' ).click(function(e)
	{
		e.preventDefault();
		return false;
	});

	jQuery("#discover-gilsa-tabs").on('change.zf.tabs', function(e){
		var background = jQuery(this).find('.is-active a').attr('data-background');
		jQuery("#tabs_bg").css("background", '#f0f0f0 url(' + background + ')');
	}).trigger('change.zf.tabs');

	// Start the typing effect on load
	if(jQuery('#typewriter-text').length !== 0)
	{
		_INTERVAL_VAL = setInterval(Type, 125);
	}
});